import { list } from './tags';

function endpoints(builder) {
  return {
    getExhibitorMilestonesByFair: builder.query({
      query: ({ fairId }) => `tefaf/tefafportal/milestones/list/${fairId}`,
      providesTags: list,
    }),
  };
}

export { endpoints };
